export default "__VITE_ASSET__ZxQZF43t__"